/**
 * 车辆维修实体
 */
import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    rff,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '车辆维修';

const Option = Select.Option;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [carUlid, setCarUlid] = useState('');
    const [time, setTime] = useState(currentDate);
    const [applyUsername, setApplyUsername] = useState('');
    const [applyDisplayname, setApplyDisplayname] = useState('');
    const [amount, setAmount] = useState(0.00);
    const [type, setType] = useState('');
    const [detail, setDetail] = useState('');
    const [repairFactory, setRepairFactory] = useState('');
    const [faultCause, setFaultCause] = useState('');
    const [faultDescription, setFaultDescription] = useState('');

    const [mLists, setMLists] = useState([]);

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setCarUlid('');
        setTime(currentDate);
        setApplyUsername('');
        setApplyDisplayname('');
        setAmount(0.00);
        setType('');
        setDetail('');
        setRepairFactory('');
        setFaultCause('');
        setFaultDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setCarUlid(props.record.car_ulid);
            setTime(props.record.time);
            setApplyUsername(props.record.apply_username);
            setApplyDisplayname(props.record.apply_displayname);
            setAmount(props.record.amount);
            setType(props.record.type);
            setDetail(props.record.detail);
            setRepairFactory(props.record.repair_factory);
            setFaultCause(props.record.fault_cause);
            setFaultDescription(props.record.fault_description);
        }
    }, [props.record]);

    useEffect(() => {
        const params = {
            'rss': 'list',
            'page_size': CNF.pageSize * 100,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.sealApi}users${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    setMLists(data.dat);
                } else {
                    setMLists([])
                }
            }
        })
    }, [])

    const ok = () => {
        //  参数校验
        if (carUlid === '') {
            message.error('车牌号码不能为空！');
            return;
        }
        if (type === '') {
            message.error('维修类型不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'car/repairs' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'car_ulid': carUlid,
                'time': time,
                'apply_username': applyUsername,
                'apply_displayname': applyDisplayname,
                'amount': amount,
                'type': type,
                'detail': detail,
                'repair_factory': repairFactory,
                'fault_cause': faultCause,
                'fault_description': faultDescription
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>{rff}车牌号码</Col>
                    <Col span={11} offset={2}>{rff}维修类型</Col>
                    <Col span={11}>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            onChange={(value) => setCarUlid(value)}
                            value={carUlid}
                        >
                            disabled={loading}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                            <Option value=''>请选择车辆</Option>
                            {
                                props.carLists && props.carLists.map((item, index) => {
                                    return <Option key={index} value={item.key}>{item.license_number}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={11} offset={2}>
                        <Select
                            style={{ width: '100%' }}
                            value={type}
                            onChange={(value) => setType(value)}
                        >
                            <Option value=''>请选择类型</Option>
                            {
                                CNF.repairTypes && CNF.repairTypes.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>维修时间</Col>
                    <Col span={11} offset={2}>维修金额</Col>
                    <Col span={11}>
                        <DatePicker
                            placeholder='请选择日期'
                            style={{ width: '100%' }}
                            value={dayjs(time, 'YYYY-MM-DD')}
                            onChange={(_, dateString) => setTime(dateString)}

                            disabled={loading}
                        />
                    </Col>

                    <Col span={11} offset={2}>
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            min={0}
                            step='0.01'
                            value={amount}
                            onChange={(value) => setAmount(value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>申请人员</Col>
                    <Col span={11} offset={2}>维修厂家</Col>
                    <Col span={11}>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            value={applyUsername}
                            onChange={(value, option) => {
                                setApplyUsername(value);
                                setApplyDisplayname(option.props.children === '' ? '' : option.props.children);
                            }}
                            disabled={loading}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            <Option value=''>请选择人员</Option>
                            {
                                mLists.length && mLists.map((item) => {
                                    return <Option key={item['username']} value={item['username']}>{item['displayname']}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder='请输入'
                            value={repairFactory}
                            onChange={(e) => setRepairFactory(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>维修明细</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 2, maxRows: 3 }}
                            value={detail}
                            onChange={(e) => setDetail(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>故障描述</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 2, maxRows: 3 }}
                            value={faultDescription}
                            onChange={(e) => setFaultDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>故障原因</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 2, maxRows: 3 }}
                            value={faultCause}
                            onChange={(e) => setFaultCause(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity